import React, { useEffect } from 'react';
import PageContainer from '../PageContainer';
import PaddedContent from '../../components/housing/PaddedContent';
import { RouteComponentProps, useParams } from 'react-router';
import FormDetails from '../forms/FormDetails';
import { Button, LinkButton } from '../../components/common';
import { Routes } from '../../constants/routes';
import styled from 'styled-components/macro';
import { FlexRow } from '../../components/basic/Flex';
import { useMessageGetter } from 'react-message-context';
import { useKennoTenant } from '../../context/kennoTenantContext';
import { loadOwnForms } from '../../context/kennoTenantActions';

const ButtonRow = styled(FlexRow)`
  @media print {
    display: none;
  }
`;

const FormPage = ({ history }: RouteComponentProps) => {
  const { id: formId } = useParams<{ id?: string }>();
  const [{ ownForms }, dispatch] = useKennoTenant();
  const t = useMessageGetter('common');

  useEffect(() => {
    loadOwnForms(dispatch);
  }, [dispatch]);

  const form = ownForms.data?.find((form) => form.id === formId);

  if (!form) return <></>;

  return (
    <PageContainer history={history}>
      <PaddedContent>
        <FormDetails form={form}>
          <ButtonRow gap="16px">
            <LinkButton to={Routes.OwnForms.ALL_FORMS} icon="arrowBackward" primary>
              {t('back')}
            </LinkButton>
            <Button onClick={window.print} icon="print">
              {t('print')}
            </Button>
          </ButtonRow>
        </FormDetails>
      </PaddedContent>
    </PageContainer>
  );
};

export default FormPage;
